<template>
  <div
      :class="this.activePlan === this.planName ? 'selectplan' : 'plan'"
      @click="updateActivePlan"
      @keydown.space="updateActivePlan"
  >
    <div
        style="text-align:right;"
        v-if="this.activePlan === this.planName"
    >
      <svg
          height="20px"
          version="1.1"
          viewBox="0 0 200 200"
          width="20px"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
            fill="none"
            fill-rule="evenodd"
            id="Page-1"
            stroke="none"
            stroke-width="1"
        >
          <g
              fill-rule="nonzero"
              id="checkmark-outline"
          >
            <path
                d="M31.1442786,171.840796 C5.2779518,146.858262 -5.09578082,109.862896 4.01023318,75.0738981 C13.1162472,40.2848999 40.2848999,13.1162472 75.0738981,4.01023318 C109.862896,-5.09578082 146.858262,5.2779518 171.840796,31.1442786 C209.549474,70.1869539 209.010186,132.247241 170.628714,170.628714 C132.247241,209.010186 70.1869539,209.549474 31.1442786,171.840796 Z"
                fill="#F08F00"
                id="Shape"
            />
            <polygon
                fill="#FFFFFF"
                id="Path"
                points="66.6666667 89.4527363 89.5522388 112.437811 132.338308 69.6517413 146.268657 83.7810945 89.5522388 140.298507 52.7363184 103.482587 66.6666667 89.3532338"
            />
          </g>
        </g>
      </svg>
    </div>
    <div
        style="text-align:right;"
        v-else
    >
      <svg
          height="20px"
          version="1.1"
          viewBox="0 0 200 200"
          width="20px"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
            fill="none"
            fill-rule="evenodd"
            id="Page-1"
            stroke="none"
            stroke-width="1"
        >
          <g
              fill-rule="nonzero"
              id="checkmark-outline"
          >
            <path
                d="M31.1442786,171.840796 C5.2779518,146.858262 -5.09578082,109.862896 4.01023318,75.0738981 C13.1162472,40.2848999 40.2848999,13.1162472 75.0738981,4.01023318 C109.862896,-5.09578082 146.858262,5.2779518 171.840796,31.1442786 C209.549474,70.1869539 209.010186,132.247241 170.628714,170.628714 C132.247241,209.010186 70.1869539,209.549474 31.1442786,171.840796 Z"
                fill="#FFFFFF"
                id="Shape"
            />
            <polygon
                fill="#FFFFFF"
                id="Path"
                points="66.6666667 89.4527363 89.5522388 112.437811 132.338308 69.6517413 146.268657 83.7810945 89.5522388 140.298507 52.7363184 103.482587 66.6666667 89.3532338"
            />
          </g>
        </g>
      </svg>
    </div>

    <div class="d-flex">
      <p style="margin-bottom:4px;font-size: 13px;">
        {{ this.planDetailName }}
      </p>
      <p style="margin-bottom:4px;font-size: 13px; color: #F08F00; font-weight: bold" v-if="isAgreement">
        （契約中）
      </p>
    </div>
    <p style="margin-bottom:2px;font-size: 15px;font-weight: bold">
      {{ this.planDollars }}
    </p>
    <p style="margin-bottom:10px;font-size: 13px;">
      {{ this.planGigs }}
    </p>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'activePlan',
    event: 'onUpdatePlan'
  },
  props: ['planDetailName', 'planName', 'planGigs', 'planDollars', 'activePlan', 'isAgreement'],
  methods: {
    updateActivePlan() {
      this.$emit('onUpdatePlan', this.planName)
    }
  }
}
</script>
<style>
.plan {
  border: 1px solid #BBBBBB;
  border-radius: 4px;
  padding: 4px 4px 0px 24px;
}

.selectplan {
  border: 1px solid #F08F00;
  border-radius: 4px;
  padding: 4px 4px 0px 24px;
}
</style>
